export default __webpack_public_path__ + "static/media/Beca_Email_Page_Obrigado.088ea990.jpg";